import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrder, SearchQueryOrderDirection } from "types/generated";

export enum SPACE_USERS_COLUMN_ID {
  NAME = "NAME",
  ROLE = "ROLE",
  GRANTED_VIA = "GRANTED_VIA",
}

export const SPACE_USERS_COLUMNS_STORAGE_KEY = "spaceDetailsUsersColumnsConfig";
export const SPACE_USERS_LIMIT_STORAGE_KEY = "spaceDetailsUsersLimit";
export const SPACE_USERS_FILTERS_ORDER_KEY = "spaceDetailsUsersFiltersOrder";
export const SPACE_USERS_INITIAL_LIMIT = 50;

export const SPACE_USERS_COLUMN_CONFIG: Record<SPACE_USERS_COLUMN_ID, TableColumnMeta> = {
  [SPACE_USERS_COLUMN_ID.NAME]: {
    id: SPACE_USERS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: 2000,
    allowsSorting: true,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_USERS_COLUMN_ID.ROLE]: {
    id: SPACE_USERS_COLUMN_ID.ROLE,
    title: "Role",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_USERS_COLUMN_ID.GRANTED_VIA]: {
    id: SPACE_USERS_COLUMN_ID.GRANTED_VIA,
    title: "Granted via",
    tooltip:
      "Shows the access origin: a direct assignment on this space, propagation from a parent space, or an IdP group",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    // Not sortable: the backend's only candidate sort key (`space`) is a per-user aggregate that
    // never reflects group attribution, so it wouldn't match this column's per-row values.
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
};

export const SPACE_USERS_SORT_CONFIG: Record<string, string> = {
  [SPACE_USERS_COLUMN_ID.NAME]: "name",
};

export const SPACE_USERS_INITIAL_ORDER_BY: SearchQueryOrder = {
  field: SPACE_USERS_SORT_CONFIG[SPACE_USERS_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
